import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";

export const ToolTipWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: inherit;
`;

export const TooltipContainer = styled.div<{
  variant: string;
}>`
  position: absolute;
  max-width: 228px;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  z-index: 1000;

  /* Set flex direction based on variant */
  flex-direction: ${(props) =>
    props.variant === "left" || props.variant === "right" ? "row" : "column"};

  /* Position the tooltip relative to the trigger element */
  ${({ variant }) =>
    variant === "top" &&
    `
      top: calc(100% + 8px);
      left: 50%;
      transform: translateX(-50%);
    `}

  ${({ variant }) =>
    variant === "bottom" &&
    `
      bottom: calc(100% + 8px);
      left: 50%;
      transform: translateX(-50%);
    `}
  
  ${({ variant }) =>
    variant === "left" &&
    `
     left: calc(100% + 8px);
      top: 50%;
      transform: translateY(-50%);
    `}
  
  ${({ variant }) =>
    variant === "right" &&
    `
      right: calc(100% + 8px);
      top: 50%;
      transform: translateY(-50%);
    `}
`;

export const TooltipTextContainer = styled.div`
  display: flex;
  padding: 8px;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 4px;
  background-color: ${colorGuide.lightComponents.toolTip.bgColor};
  width: max-content;
  height: 100%;
  max-width: 228px;
`;

export const IconContainer = styled.img<{
  variant: string;
}>`
  width: ${(props) =>
    props.variant === "left" || props.variant === "right" ? "12px" : "20px"};
  height: ${(props) =>
    props.variant === "left" || props.variant === "right" ? "20px" : "12px"};
  flex-shrink: 0;
  transform: ${({ variant }) =>
    variant === "left"
      ? "rotate(180deg)"
      : variant === "bottom"
      ? "rotate(180deg)"
      : "none"};
`;
